import { useEffect, useState } from 'react';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import useApi from '../../../../hook/useApi';
import { ButtonCancel, ButtonPrimary } from '../../../../utils/Button';
import FocusControl from '../../../../utils/FocusControl';
import { addOption, SelectOption } from '../../../../utils/InputField';

function ModalUpdateAuthorization({ data, closeModal, handleReload }) {
    const [isError, setIsError] = useState('');
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        AuthorizeUserId: data?.id,
        AuthorizeUserName: data?.fullName
    });
    const [adminList, setAdminList] = useState([]);
    const { setMessage } = useTemplate();
    const { get, put } = useApi();
    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name) {
            if (name === 'AuthorizeUserId') {
                const selectedUser = adminList.find((user) => user.id === value);
                setFormData((prev) => ({
                    ...prev,
                    [name]: value,
                    AuthorizeUserName: selectedUser ? selectedUser.fullName : ''
                }));
            } else {
                setFormData((prev) => ({ ...prev, [name]: value }));
            }
        }
    };
    const handleSaveClick = (e) => {
        e?.preventDefault();
        setLoading(true);
        put('api/setting/invoice-config/update-invoice-authorization', formData)
            .then(({ error, referenceName, message }) => {
                if (error) {
                    setIsError(referenceName);
                    throw new Error(message || 'Failed to update invoice note');
                }
                closeModal();
                handleReload();
                setMessage({ type: 'success', text: message });
            })
            .catch((err) => {
                setMessage({ type: 'error', text: err?.message || 'Something went wrong' });
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        // -- load admin list
        get('api/setting/invoice-config/authorize-users')
            .then(({ data: resData }) => {
                setAdminList(resData.users || []);
            })
            .catch(() => {
                setAdminList([]);
            });
    }, []);

    FocusControl(isError, setIsError, formData);
    return (
        <form onSubmit={handleSaveClick}>
            <div className="flex flex-col gap-y-3 mb-5">
                <SelectOption
                    label="Authorize User"
                    name="AuthorizeUserId"
                    placeholder="user..."
                    formData={formData}
                    onChange={handleChange}
                    options={adminList.map((user) => addOption(user?.id, user?.fullName, user?.id))}
                    required
                />
            </div>

            <div className="flex justify-end">
                <div className="flex items-center gap-x-3">
                    <ButtonCancel title="Cancel" onClick={closeModal} />
                    <ButtonPrimary title="Save" btnType="submit" loading={loading} />
                </div>
            </div>
        </form>
    );
}

export default ModalUpdateAuthorization;
